import React from "react";

function icCheck({ height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '16'}
      height={height || '14'}
      fill="none"
      viewBox="0 0 16 14"
    >
      <path
        fill="#24206B"
        fillRule="evenodd"
        d="M13.061.564c.678-.759 1.771-.75 2.44.017.636.727.663 1.876.088 2.64l-.102.123-9.025 10.092c-.624.698-1.603.75-2.28.146l-.115-.113L.543 9.716C-.15 8.976-.184 7.74.47 6.954c.619-.744 1.632-.817 2.327-.194l.113.11 2.31 2.462L13.062.564z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default icCheck;



// WEBPACK FOOTER //
// ./src/app/elements/Icon/ic-check.js